import { ReactCompareSlider, ReactCompareSliderImage } from 'react-compare-slider';
import { PIC_SLIDE_GALLERY, PIC_SLIDE_RETOUCH } from '../config/media';

function SliderHandle() {
  return (
    <div
      className="flex items-center justify-center"
      style={{
        height: '100%',
        width: '44px',
        touchAction: 'none',
        pointerEvents: 'auto',
      }}
    >
      <div className="relative flex h-full flex-col items-center">
        <div className="w-px flex-1 bg-white" />

        <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white shadow-md">
          <svg width="18" height="10" viewBox="0 0 18 10" fill="none" aria-hidden="true">
            <path d="M5 1L1 5L5 9" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M13 1L17 5L13 9" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
        </div>

        <div className="w-px flex-1 bg-white" />
      </div>
    </div>
  );
}

function CompareSlide({ before, after, alt = 'Сравнение фото' }) {
  return (
    <div className="aspect-[3/4] w-full overflow-hidden bg-neutral-100">
      <ReactCompareSlider
        portrait={false}
        position={50}
        handle={<SliderHandle />}
        itemOne={
          <ReactCompareSliderImage
            src={before}
            alt={`${alt} — до`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        }
        itemTwo={
          <ReactCompareSliderImage
            src={after}
            alt={`${alt} — после`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        }
        style={{
          width: '100%',
          height: '100%',
          touchAction: 'none',
          userSelect: 'none',
        }}
      />
    </div>
  );
}

function PicSlide() {
  return (
    <section className="bg-white">
      <div className="mx-auto max-w-6xl px-5 py-12 md:px-10 md:py-20">
        <div className="flex flex-col gap-8 md:flex-row md:items-center md:gap-16">
          <div className="w-full md:w-1/2">
            <CompareSlide
              before={PIC_SLIDE_RETOUCH.before}
              after={PIC_SLIDE_RETOUCH.after}
              alt="Ретушь и цветокоррекция"
            />
          </div>

          <div className="flex w-full flex-col justify-center text-left md:w-1/2">
            <p className="mb-4 text-base font-medium leading-snug text-black md:mb-5 md:text-lg">
              примеры моей авторской ретуши и цветокоррекции
            </p>
            <p className="m-0 text-sm leading-relaxed text-neutral-600 md:text-[0.9375rem]">
              вы можете заметить, что я не меняю черты лица, сохраняю текстуру кожи и визуально
              «чищу» фотографию
            </p>
          </div>
        </div>
      </div>

      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-5 px-5 pb-12 md:grid-cols-2 md:gap-6 md:px-10 md:pb-20">
        {PIC_SLIDE_GALLERY.map((slide, index) => (
          <CompareSlide
            key={`${slide.before}-${index}`}
            before={slide.before}
            after={slide.after}
            alt={`Галерея ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
}

export default PicSlide;
